var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-background"},[_c('div',{staticClass:"modal-box component-center flex-col flex-center"},[_c('p',[_vm._v(_vm._s(_vm.modalContent))]),_c('button',{on:{"click":function () {
          _vm.closeModal();
        }}},[_vm._v("\n      OK\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }